import React, { Component } from 'react';
import './SelectDiceTypeApp.css'
import db from './Database/Database';

class SelectDiceTypeApp extends Component {
  onSubmit(evnt) {
    evnt.preventDefault();
    var diceToUse = this.refs.select.value;
    if (diceToUse.length === 0) {
      return
    }
    db.setDiceType(diceToUse);
  }

  render() {
    return (
      <form className="dicetype_form" onSubmit={this.onSubmit.bind(this)}>
        <select ref="select">
          <option value="">Select Dice To Use ...</option>
          <option value="EOT">Starwars</option>
          <option value="WARHAMMER">Warhammer (in-progress)</option>
        </select>
        <button className="dicetype_btn">Go</button>
      </form>
    );
  }
}

export default SelectDiceTypeApp;



// WEBPACK FOOTER //
// ./src/SelectDiceTypeApp.js